module.exports = __webpack_public_path__ + "static/media/bat_circle.ed9ebb36.png";